export const areaTypeRoutes = {
	areaTypeIndex: '/area-types',
	areaTypeAdd: '/area-types/add',
	areaTypeHistory: (id?: string) => `/area-types/${id ?? ':id'}/history`,
	areaTypeEdit: (id?: string) => `/area-types/${id ?? ':id'}`
} as const
